import styled from 'styled-components'

export const Container = styled.div`
  width: 100vw;
  max-width: 1300px;
  margin: 100px auto 0;
  padding: 1rem;
`
export const HeaderCard = styled.div`
  button {
    display: flex;
    align-items: center;
    background: none;
    border: none;
    margin: 0;
    margin-bottom: 1rem;
    font-weight: bold;
    font-size: 14px;

    color: ${({ theme }) => `rgb(${theme.grayscale[100]})`};
  }
`
export const Card = styled.div`
  width: auto;
  height: auto;
  hr {
    mix-blend-mode: normal;
    border: 1px solid ${({ theme }) => `rgb(${theme.component.accent})`};
  }
`
export const CardBody = styled.div`
  display: flex;
  flex-direction: column;
  min-width: 18rem;
  width: 100%;
  background-color: ${({ theme }) => `rgb(${theme.background.high})`};
  margin-bottom: 0.5rem;
  border-radius: 8px;
  border: solid 2px ${({ theme }) => `rgb(${theme.component.accent})`};
`
export const TitleCard = styled.div`
  display: flex;
  flex-direction: column;
  // justify-content: space-between;
  // align-items: center;
  color: ${({ theme }) => `rgb(${theme.grayscale[100]})`};
  line-height: 136%;
  font-size: 18px;
  margin-left: 1rem;

  .header-title {
    display: flex;
    flex-direction: column;
    margin: 0;
    margin-top: 2rem;
    padding: 0;

    h3 {
      font-size: 1.25rem;
      margin: 0;
    }
    p {
      font-size: 14px;
      color: ${({ theme }) => `rgb(${theme.grayscale[200]})`};
      font-weight: 500;
      margin-top: 0;
    }
  }

  span {
    width: 7rem;
    text-align: center;
    color: ${({ theme }) => `rgb(${theme.green[200]})`};
    background: ${({ theme }) => `rgb(${theme.green[600]})`};
    border-radius: 3.25px;
    font-weight: bold;
    font-size: 0.87rem;
    margin-right: 1rem;
  }
`
export const HeaderContendCard = styled.div`
  margin: 0 1rem 1rem !important;

  p {
    margin: 0;
    font-size: 0.75rem;
    line-height: 1.5rem;
    color: ${({ theme }) => `rgba(${theme.grayscale[200]})`};
    font-weight: 500;

    b {
      font-size: 1rem;
      line-height: 1.7rem;
    }
  }

  div {
    flex-direction: column !important;
    justify-content: flex-start !important;
    align-items: flex-start !important;
  }

  h3 {
    font-size: 1rem;
    line-height: 1.375rem;
    font-style: italic;
    font-weight: 500;
    color: ${({ theme }) => `rgba(${theme.background.high})`};
    margin: 0;
    width: 100%;
    border-left: 3px solid ${({ theme }) => `rgb(${theme.primary.base})`};
    background: ${({ theme }) => `rgb(${theme.primary[300]})`};
    padding: 0.5rem;
  }

  button {
    width: fit-content;

    font-weight: 700;

    background: transparent;

    margin-top: 0.5rem;
    padding: 0.5rem 1rem;

    border-radius: 4px;
    border: ${({ theme }) => `1px solid rgb(${theme.component.accent})`};

    color: ${({ theme }) => `rgba(${theme.grayscale[100]}, 0.8)`};
  }

  @media only screen and (min-width: 600px) {
    display: flex;
    flex-direction: column;
    margin: 0;
    margin-left: 1rem;
  }
  @media only screen and (min-width: 1024px) {
    display: flex;
    // flex-direction: row-reverse;
    min-width: 60rem;
    margin: 1rem;
    div {
      display: flex;
      flex-direction: row;
      justify-content: end;
      align-items: center;
      // width: 40%;
      h3 {
        margin-left: 0.5rem;
      }
    }
    span {
      width: 60%;
    }
  }
`
export const ContentCard = styled.div`
  display: flex;
  flex-direction: column;
  background-color: ${({ theme }) => `rgb(${theme.background.low})`};
  margin: 0;
  width: 100%;
  img {
    margin: -1rem;
    margin-left: -0.3rem;
    margin-right: 0;
    border-radius: 50%;
  }
  p {
    font-weight: bold;
    font-size: 17px;
    line-height: 28px;
    margin-left: 1rem;
    margin-bottom: 0.5rem;
  }
  .doubt {
    overflow-y: auto;
    display: block;
    text-overflow: ellipsis;
    margin: 1rem;
    margin-top: 0;
    margin-bottom: 1rem;
    ::-webkit-scrollbar {
      width: 1px;
    }
  }
  @media only screen and (min-width: 600px) {
    .doubt {
      max-width: 40rem;
      overflow: hidden;
      display: block;
      text-overflow: ellipsis;
      margin: 2rem;
      margin-top: 0;
      margin-bottom: 1rem;
    }
    p {
      margin-left: 2rem;
    }
  }

  @media only screen and (min-width: 1024px) {
    p {
      margin-top: 0;
    }
  }
`
export const DoubtCard = styled.div`
  min-width: 16rem;
  min-height: 8rem;
  margin: 1rem;
  border-radius: 8px;
  box-shadow: 0px 7px 20px rgba(0, 0, 0, 0.25);
  background: ${({ theme }) => `rgb(${theme.background.doubtCard})`};
  img {
    box-shadow: 0px 12px 25px rgba(0, 0, 0, 0.12);
  }
  @media only screen and (min-width: 1024px) {
    width: 44rem;
    margin-left: 6rem;
    img {
      margin-left: -3.5rem;
      margin-bottom: -1.5rem;
    }
    span {
      margin: 0rem;
    }
  }
`
export const AnsweredCard = styled.div`
  min-width: 16rem;
  min-height: 8rem;
  margin: 1rem;
  border-radius: 13px;
  background: ${({ theme }) => `rgb(${theme.green.base})`};
  color: ${({ theme }) => `rgb(${theme.background.high})`};
  .doubt {
    ::-webkit-scrollbar {
      color: #fafafa;
    }
  }
  @media only screen and (min-width: 1024px) {
    width: 44rem;
    margin-left: auto;
    margin-right: 6rem;
    img {
      margin-left: 45rem;
      margin-top: -0.1rem;
    }
  }
`
export const FooterCard = styled.div`
  margin: 1rem;
  margin-top: 0;
  width: 16rem;
  display: flex;
  flex-direction: column;
  align-items: center;
  h3 {
    font-size: 18px;
    color: ${({ theme }) => `rgb(${theme.grayscale[200]})`};
  }
  @media only screen and (min-width: 1024px) {
    margin-left: 76%;
  }
`

interface IHandsOkNo {
  util?: 0 | 1 | 2
}

export const HandsOkNo = styled.div<IHandsOkNo>`
  width: 16rem;
  height: 3rem;
  display: grid;
  grid-template-columns: 1fr 0.25fr 1fr;
  align-content: space-around;
  border-radius: 12px;
  box-shadow: 0px 7px 20px rgba(0, 0, 0, 0.05);
  margin: 0;
  .to-up,
  .to-down {
    margin-left: 3rem;
    margin-top: 0.5rem;
  }
  .clickable {
    cursor: pointer;
  }
  hr {
    height: 50%;
    margin-bottom: 2rem;
  }

  .to-up {
    color: ${(props) =>
      props?.util === 1
        ? `rgb(${props.theme.greenProgress[300]})`
        : `rgb(${props.theme.grayscale[200]})`};
  }

  .to-down {
    color: ${(props) =>
      props?.util === 2 ? `rgb(${props.theme.red.base})` : `rgb(${props.theme.grayscale[200]})`};
  }
`

export const TextQuestion = styled.div`
  margin: 1rem;

  form {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;

    button {
      border: none;
      background: none;
      svg {
        color: ${({ theme }) => `rgb(${theme.grayscale[200]})`};
      }
    }
  }
`
